<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header p-3 pt-2 d-flex align-items-center">
            <div
              class="icon icon-lg icon-shape shadow text-center border-radius-xl bg-gradient-success shadow-dark me-3"
              style="margin-top: -1.5rem">
              <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">add_circle</i>
            </div>
            <h6 class="mb-0">{{ $t('mating.Update_birth') }}</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="row mb-5">
          <div class="col-lg-3">
            <birth-side-nav v-model:offspringAdded="offspringAdded" />
          </div>
          <div class="col-lg-9 mt-lg-0 mt-4">
            <birth-detail v-model:offspringAdded="offspringAdded" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BirthSideNav from "./components/BirthSideNav.vue"
import BirthDetail from "./components/BirthDetail.vue"

export default {
    name: 'Birth_register_page',
    components: {
        BirthSideNav,
        BirthDetail
    },
    data() {
        return {
            Id: '',
            mating: [],
            gets: [],
            offspringAdded: false,
        }
    },
    async mounted() {
        
    },
}
</script>